// src/admin/TranscriptManagement.js - Đồng bộ Khóa Bảng Điểm Thời Gian Thực
import React, { useState, useEffect, useContext } from 'react';
import { StudentContext } from '../StudentContext';
import { subscribeAllTranscriptLocks, updateTranscriptLockRealtime } from '../FirebaseService';
import './TranscriptManagement.css';

const TranscriptManagement = () => {
  const { currentYearId, allBlocks } = useContext(StudentContext);
  const [locksMap, setLocksMap] = useState({});
  const [loading, setLoading] = useState(true);

  const allClasses = Object.values(allBlocks).flat();

  // 🌟 LẮNG NGHE THỜI GIAN THỰC TOÀN BỘ TRẠNG THÁI KHÓA BẢNG ĐIỂM
  useEffect(() => {
    if (!currentYearId) return;

    const unsubscribe = subscribeAllTranscriptLocks(currentYearId, (fetchedLocks) => {
      setLocksMap(fetchedLocks);
      setLoading(false);
    });

    return () => unsubscribe();
  }, [currentYearId]);

  const handleToggleLock = (classId, semester, field) => async (e) => {
    const isChecked = e.target.checked;
    const currentClassLock = locksMap[classId] || {};
    const currentSemLock = currentClassLock[semester] || {};

    const updatedStructure = {
      ...currentClassLock,
      [semester]: {
        ...currentSemLock,
        [field]: isChecked
      }
    };

    try {
      await updateTranscriptLockRealtime(currentYearId, classId, updatedStructure);
    } catch (error) {
      console.error('Lỗi khi đổi khóa:', error);
    }
  };

  if (loading) {
    return <div className="tm-container"><p>⏳ Đang nạp danh sách khóa điểm...</p></div>;
  }

  return (
    <div className="tm-container">
      <h2 className="tm-title">Quản Lý Khóa Cột Bảng Điểm</h2>
      <p className="tm-subtitle">Bật / Tắt công tắc để khóa hoặc mở quyền nhập điểm của từng cột cho Giáo lý viên trong thời gian thực.</p>

      <div className="tm-table-wrapper">
        <table className="tm-table">
          <thead>
            <tr>
              <th rowSpan="2" className="tm-sticky-head">Lớp Học</th>
              <th colSpan="4">Học Kỳ 1</th>
              <th colSpan="4">Học Kỳ 2</th>
            </tr>
            <tr>
              <th>Miệng</th>
              <th>15p</th>
              <th>1 Tiết</th>
              <th>Thi</th>
              <th>Miệng</th>
              <th>15p</th>
              <th>1 Tiết</th>
              <th>Thi</th>
            </tr>
          </thead>
          <tbody>
            {allClasses.map((c) => {
              const classLock = locksMap[c.id] || {};
              const sem1 = classLock.semester1 || {};
              const sem2 = classLock.semester2 || {};

              return (
                <tr key={c.id}>
                  <td className="tm-sticky-col">{c.name}</td>
                  {/* HK1 */}
                  {['oral', 'fifteenMinutes', 'onePeriod', 'exam'].map((f) => (
                    <td key={`sem1-${f}`}>
                      <label className="tm-switch">
                        <input
                          type="checkbox"
                          checked={Boolean(sem1[f])}
                          onChange={handleToggleLock(c.id, 'semester1', f)}
                        />
                        <span className="tm-slider"></span>
                      </label>
                    </td>
                  ))}
                  {/* HK2 */}
                  {['oral', 'fifteenMinutes', 'onePeriod', 'exam'].map((f) => (
                    <td key={`sem2-${f}`}>
                      <label className="tm-switch">
                        <input
                          type="checkbox"
                          checked={Boolean(sem2[f])}
                          onChange={handleToggleLock(c.id, 'semester2', f)}
                        />
                        <span className="tm-slider"></span>
                      </label>
                    </td>
                  ))}
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TranscriptManagement;